export const elements = {
    ONE_WAY_TRIP_MODE: 'one-way-radio-button',
    ROUND_TRIP_MODE: 'round-trip-radio-button',
    DEPARTURE_CITY_INPUT_FIELD: 'departure-city-input-field',
    ARRIVAL_CITY_INPUT_FIELD: 'arrival-city-input-field',
    DEPARTURE_DATE_INPUT_FIELD: 'departure-date-input-field',
    ARRIVAL_DATE_INPUT_FIELD: 'arrival-date-input-field',
    DEPARTURE_DATE_DATE_PICKER: 'departure-date-picker',
    PRODUCTS_INPUT_FIELD: 'products-input-field',
    PRODUCTS_PLUS_BUTTON: 'products-add-button',
    PRODUCTS_MINUS_BUTTON: 'products-minus-button',
    PRODUCTS_NUMBER: 'products-number',
    SEARCH_BUTTON: 'search-button',
    PAX_TOOLTIP: 'tr-product-info-popup',
    PAX_TOOLTIP_TITLE: 'tr-product-info-title-popup',
    PAX_TOOLTIP_CLOSE: 'tr-product-info-close-popup',
};
